export default "__VITE_ASSET__BwVJ2weq__"